module.exports = __webpack_public_path__ + "static/img/share-pyq_light.6d41a817.png";